import { observer } from 'mobx-react-lite'
import { type TableSortOrder } from '@/components/Table'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { UserDetailsJobsTableHeaderRow } from '@/features/jobs/list/components/UserJobsTab/UserDetailsJobsTableHeaderRow'

export interface UserDetailsJobsTableHeaderRowContainerProps {
  vm: JobManagementViewModel
}

export const UserDetailsJobsTableHeaderRowContainer = observer(
  function UserDetailsJobsTableHeaderRowContainer({
    vm,
  }: UserDetailsJobsTableHeaderRowContainerProps) {
    return (
      <UserDetailsJobsTableHeaderRow
        columns={vm.columnsVm.filteredColumns
          .filter((col) => col.visible)
          .map((col) => ({
            id: col.id,
            header: col.header,
            sortable: col.sortable,
            sortOrder: vm.getSortOrder(col),
            onSort: (newSort: TableSortOrder) => {
              vm.setSortOrder(col, newSort)
            },
          }))}
      />
    )
  },
)
